import {gql} from 'graphql-tag';

export const CREATE_STORE_LOCATOR_SETTINGS = gql`
  mutation createStoreLocatorSettings($input: CreateStoreLocatorSettingsInput!) {
    createStoreLocatorSettings(input: $input) {
      id
      retailer
      accountManager
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_STORE_LOCATOR_SETTINGS = gql`
  mutation updateStoreLocatorSettings($input: UpdateStoreLocatorSettingsInput!) {
    updateStoreLocatorSettings(input: $input) {
      id
      retailer
      accountManager
      createdAt
      updatedAt
    }
  }
`;